import { render, staticRenderFns } from "./ProductSetBulkUpdateModal.vue?vue&type=template&id=239e09f9"
import script from "./ProductSetBulkUpdateModal.vue?vue&type=script&lang=ts"
export * from "./ProductSetBulkUpdateModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports